import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MenuComponent } from './menu/menu.component';
import { Router } from '@angular/router';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { TranslateService } from '@ngx-translate/core';
import { MCButtonComponent } from '@maslul/common-components';

@Component({
  selector: 'mi-app-header',
  imports: [MenuComponent,
    ClipboardModule,
    MCButtonComponent
  ],
  templateUrl: './header.html',
  styleUrl: './header.scss'
})
export class HeaderComponent {

  private translateService = inject(TranslateService);
  private router = inject(Router);
  isOpenLanguage: boolean = false;
  commonText = toSignal(this.translateService.stream('common'));

  goToHome() {
    this.router.navigate(['']);
  }

  toggleLanguage() {
    this.isOpenLanguage = !this.isOpenLanguage;
  }

  textToCopy: string = 'הטקסט הסודי שאני רוצה להעתיק כעת.';

  // 2. משתנה לשליטה בהודעת הפידבק
  isCopied: boolean = false;
  private feedbackTimeout: any;

  // 3. הפונקציה המופעלת בלחיצה
  onCopy(): void {
    // הדירקטיבה cdkCopyToClipboard מטפלת בפועל בהעתקה.
    // פונקציה זו משמשת רק להצגת פידבק למשתמש.

    this.isCopied = true;

    // נקה כל טיימר קודם כדי למנוע הצפת הודעות
    if (this.feedbackTimeout) {
      clearTimeout(this.feedbackTimeout);
    }

    // הסתר את הודעת הפידבק לאחר 2 שניות
    this.feedbackTimeout = setTimeout(() => {
      this.isCopied = false;
    }, 2000);
  }
}
